export const GscApiPath = {
  GSC_STATUS: '/api/sites/{site_id}/gsc/status', // GET Gsc Status
  GET_AUTH_URL: '/api/sites/{site_id}/gsc/auth-url', // GET Get Auth Url
  GSC_CALLBACK: '/api/gsc/callback', // GET Gsc Callback
  LIST_GSC_SITES: '/api/sites/{site_id}/gsc/sites', // GET List Gsc Sites
  ANALYZE_GSC_SITE: '/api/sites/{site_id}/gsc/analyze', // POST Analyze Gsc Site
  ANALYZE_GSC_KEYWORDS: '/api/sites/{site_id}/gsc/keyword-analysis', // POST Analyze Gsc Keywords
  DISCONNECT_GSC: '/api/sites/{site_id}/gsc/disconnect' // GET Disconnect Gsc
}

export type GscApiPath = (typeof GscApiPath)[keyof typeof GscApiPath]

export interface GscStatusVars {
  site_id: number
}

export interface GetAuthUrlVars {
  site_id: number
}

export interface GscCallbackVars {
  code?: string
  state?: string
  error?: string
}

export interface ListGscSitesVars {
  site_id: number
}

export interface AnalyzeGscSiteVars {
  site_id: number
  gsc_site_url: string
  days?: number
}

export interface DisconnectGscVars {
  site_id: number
}

export interface GscStatusResponse {
  has_credentials: boolean
  is_connected: boolean
  message: string
  // 前回の分析で選択された対象サイト（未選択なら null）
  gsc_site_url: string | null
}

export interface GetAuthUrlResponse {
  auth_url: string
  redirect_uri: string
}

export interface GscCallbackResponse {
  status: string
}

export interface GscSite {
  site_url: string
  permission_level: string
}

export interface ListGscSitesResponse {
  sites: GscSite[]
}

export interface GscMetricRow {
  clicks: number
  impressions: number
  ctr: number
  position: number
}

export interface GscKeywordRow extends GscMetricRow {
  keyword: string
}

export interface GscPageRow extends GscMetricRow {
  page: string
}

export interface GscAnalysis {
  summary: {
    total_clicks: number
    total_impressions: number
    avg_ctr: number
    avg_position: number
  }
  keywords: GscKeywordRow[]
  pages: GscPageRow[]
  keyword_count: number
  page_count: number
}

export interface AnalyzeGscSiteResponse {
  site_id: number
  analysis: GscAnalysis
}

export interface DisconnectGscResponse {
  status: string
}

export interface AnalyzeGscKeywordsVars {
  site_id: number
  keywords: string[]
  days?: number
  site_url?: string
}

export interface GscKeywordPerformance {
  keyword: string
  clicks: number
  impressions: number
  ctr: number
  position: number
}

export interface AnalyzeGscKeywordsResponse {
  connected: boolean
  gsc_site_url: string | null
  keywords: GscKeywordPerformance[]
  // 入力キーワードで絞り込んだ結果か（false = サイト全体の実績クエリ）
  filtered: boolean
  // 絞り込み後の総件数（keywords は表示回数上位100件まで）
  total_count: number
  message: string | null
}
